/** @format */

import React from 'react';
import {
	NavItemWrapper,
	NavAnimateBar,
	SelectBar,
	MenuWrapper,
	MenuVectorWrapper
} from '../styles';
import { Trans } from 'react-i18next';
import { useMenu } from './useMenu';
import VectorDown from '../../../../images/img/vectorDown.svg';
import { CSSTransition } from 'react-transition-group';
import Link from '../../Link';

const Menu = ({ i18nKey, path, children }) => {
	const { selected, navItemRef, onHover, onMouseEnter, onMouseLeave } = useMenu(
		path
	);
	return (
		<div
			ref={navItemRef}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}>
			<NavItemWrapper>
				<div>
					{
						<Link path={path}>
							<Trans i18nKey={i18nKey}></Trans>
						</Link>
					}
					{children.length > 0 && (
						<MenuVectorWrapper src={VectorDown} width="8" height="8" />
					)}
				</div>
				{selected && <SelectBar />}
				{!selected && <NavAnimateBar hover={onHover} selected={selected} />}
			</NavItemWrapper>
			<CSSTransition
				in={onHover} // 用於判斷是否出現的狀態
				timeout={300} // 動畫持續時間
				classNames="profile-modal">
				<MenuWrapper opacity={!onHover}>{children}</MenuWrapper>
			</CSSTransition>
		</div>
	);
};

export default React.memo(Menu);
